// @flow
import { handleActions } from "redux-actions";
import Record from "../flow/Record";
import { List } from "immutable";
import { LanguageSettings } from "../records/userSettings.record";
import { Post } from "../records/post.record";
import {
    completeUserSetup,
    completeUserSetupFailure,
    completeUserSetupSuccess,
    updateUserSetupProperty
} from "../actions/userSetup.actions";
import { RequestState } from "../records/request.record";
import { setupRequest } from "./request.reducer";

export class UserSetup extends Record({
    languages: List(),
    post: new Post(),
    completeUserSetupRequest: new RequestState()
}) {
    languages: List<LanguageSettings>;
    post: Post;
    completeUserSetupRequest: RequestState;
}

const requestReducer = setupRequest("completeUserSetupRequest");

const userSetup = handleActions(
    {
        [completeUserSetup]: requestReducer.start,
        [updateUserSetupProperty](state, { payload }) {
            return state.merge(payload);
        },
        [completeUserSetupSuccess]: requestReducer.success,
        [completeUserSetupFailure]: requestReducer.failure
    },
    new UserSetup()
);

export default userSetup;



// WEBPACK FOOTER //
// ./src/reducers/userSetup.reducer.js